import React, { memo, useCallback } from 'react';

// Componente para campos de texto
const TextField = memo(({ question, value, onChange, error, readonly }) => {
  // console.log(`🔍 [TEXTFIELD] Campo ${question.name}, value recibido:`, value, 'readonly:', readonly);
  
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    onChange(newValue);
  }, [onChange]);

  return (
    <input
      type="text"
      id={question.name}
      value={value || ''}
      onChange={handleChange}
      placeholder={question.hint || 'Ingrese texto'}
      required={question.required}
      className={`campo-entrada ${error ? 'campo-error' : ''}`}
      readOnly={readonly}
      disabled={readonly}
    />
  );
});

// Componente para campos de número entero
const IntegerField = memo(({ question, value, onChange, error, readonly }) => {
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    onChange(newValue);
  }, [onChange]);

  return (
    <input
      type="number"
      id={question.name}
      value={value || ''}
      onChange={handleChange}
      placeholder={question.hint || 'Ingrese un número'}
      step="1"
      required={question.required}
      className={`campo-entrada ${error ? 'campo-error' : ''}`}
      readOnly={readonly}
      disabled={readonly}
    />
  );
});

// Componente para campos de número decimal
const DecimalField = memo(({ question, value, onChange, error, readonly }) => {
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    onChange(newValue);
  }, [onChange]);

  return (
    <input
      type="number"
      id={question.name}
      value={value || ''}
      onChange={handleChange}
      placeholder={question.hint || 'Ingrese un número decimal'}
      step="0.01"
      required={question.required}
      className={`campo-entrada ${error ? 'campo-error' : ''}`}
      readOnly={readonly}
      disabled={readonly}
    />
  );
});

// Componente para campos de textarea
const TextAreaField = memo(({ question, value, onChange, error, readonly }) => {
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    onChange(newValue);
  }, [onChange]);

  return (
    <textarea
      id={question.name}
      value={value || ''}
      onChange={handleChange}
      placeholder={question.hint || 'Ingrese texto largo'}
      rows={4}
      required={question.required}
      className={`campo-entrada ${error ? 'campo-error' : ''}`}
      readOnly={readonly}
      disabled={readonly}
    />
  );
});

// Componente para campos de email
const EmailField = memo(({ question, value, onChange, error, readonly }) => {
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    onChange(newValue);
  }, [onChange]);

  return (
    <input
      type="email"
      id={question.name}
      value={value || ''}
      onChange={handleChange}
      placeholder={question.hint || 'Ingrese email'}
      required={question.required}
      className={`campo-entrada ${error ? 'campo-error' : ''}`}
      readOnly={readonly}
      disabled={readonly}
    />
  );
});

// Componente para campos de teléfono
const PhoneField = memo(({ question, value, onChange, error, readonly }) => {
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    onChange(newValue);
  }, [onChange]);

  return (
    <input
      type="tel"
      id={question.name}
      value={value || ''}
      onChange={handleChange}
      placeholder={question.hint || 'Ingrese teléfono'}
      required={question.required}
      className={`campo-entrada ${error ? 'campo-error' : ''}`}
      readOnly={readonly}
      disabled={readonly}
    />
  );
});

// Componente para campos de URL
const UrlField = memo(({ question, value, onChange, error, readonly }) => {
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    onChange(newValue);
  }, [onChange]);

  return (
    <input
      type="url"
      id={question.name}
      value={value || ''}
      onChange={handleChange}
      placeholder={question.hint || 'Ingrese URL'}
      required={question.required}
      className={`campo-entrada ${error ? 'campo-error' : ''}`}
      readOnly={readonly}
      disabled={readonly}
    />
  );
});

TextField.displayName = 'TextField';
IntegerField.displayName = 'IntegerField';
DecimalField.displayName = 'DecimalField';
TextAreaField.displayName = 'TextAreaField';
EmailField.displayName = 'EmailField';
PhoneField.displayName = 'PhoneField';
UrlField.displayName = 'UrlField';

export {
  TextField,
  IntegerField,
  DecimalField,
  TextAreaField,
  EmailField,
  PhoneField,
  UrlField
};